import {
  SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_BEGIN,
  SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_SUCCESS,
  SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_FAILURE,
  SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function updateLineaFinanciera({ updateLinea = {} } = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let lineasAux = [...updateLinea.asignacionLineas.lineas];
      let lineasDeletedAux = [...updateLinea.asignacionLineas.lineasDeleted];
      let lineas = [];
      lineasAux.forEach((linea) => {
        if (linea.newLinea) {
          lineas.push(
            {
              brandId: linea.data.idBrand,
              brand: linea.data.nameBrand,
              modelId: linea.data.idModel,
              model: linea.data.nameModel,
              versionId: linea.data.idVersion,
              version: linea.data.nameVersion,
              yearMMV: linea.data.year,
              yearMMV_desde: linea.data.year_desde,
              deleted: false,
              newLinea: true,
              ventaDirecta: linea.data.ventaDirecta,
              ventaConvencional: linea.data.ventaConvencional,
              car_lot_id: linea.data.car_lot_id
            }
          );
        }
      });
      lineasDeletedAux.forEach((linea) => {
        lineas.push(
          {
            id: linea.id,
            brandId: linea.data.idBrand,
            brand: linea.data.nameBrand,
            modelId: linea.data.idModel,
            model: linea.data.nameModel,
            versionId: linea.data.idVersion,
            version: linea.data.nameVersion,
            yearMMV: linea.data.year,
            yearMMV_desde: linea.data.year_desde,
            deleted: true,
            newLinea: false,
            car_lot_id: linea.data.car_lot_id
          }
        );
      });
      let cuotasAux = [...updateLinea.datosFinancieros.cuotas];
      let cuotasDeletedAux = [...updateLinea.datosFinancieros.cuotasDeleted];
      cuotasDeletedAux.forEach((cuota) => {
        cuota.deleted = true;
        cuotasAux.push(cuota);
      });
      let body = {
        lineaCredito: {
          id: updateLinea.id,
          entidadOtorganteId: updateLinea.datosFinancieros.entidadOtorgante.value ? updateLinea.datosFinancieros.entidadOtorgante.value : '',
          entidadOtorgante: updateLinea.datosFinancieros.entidadOtorgante.label ? updateLinea.datosFinancieros.entidadOtorgante.label : '',
          tipoCreditoId: updateLinea.datosFinancieros.tipoCredito.value ? updateLinea.datosFinancieros.tipoCredito.value : '',
          lineaCreditoBancaria: updateLinea.datosFinancieros.lineaCreditoBancaria,
          lineaComercial: updateLinea.datosFinancieros.lineaComercial,
          tipoTasa: updateLinea.datosFinancieros.tipoTasa.value ? updateLinea.datosFinancieros.tipoTasa.value : '',
          requisitos: updateLinea.datosFinancieros.requisitos,
          fechaVigenciaIni: updateLinea.datosFinancieros.fechaVigenciaIni,
          fechaVigenciaFin: updateLinea.datosFinancieros.fechaVigenciaFin,
          promocionClienteBanco: updateLinea.datosFinancieros.promocionClienteBanco,
          beneficio: updateLinea.datosFinancieros.beneficio,
          bloqueado: updateLinea.datosFinancieros.bloqueado,
          tipoMMV: updateLinea.asignacionLineas.tipoVehiculo ? 1 : 0,
          exceedFinanceLimit: updateLinea.datosFinancieros.exceedFinanceLimit,
        },
        cuotas: cuotasAux,
        lineas: lineas
      };
      let params = {
        params: {
          id: updateLinea.id
        }
      }
     
      const doRequest = axios.put(REACT_APP_API_SF + "/credits", body, params);
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissUpdateLineaFinancieraError() {
  return {
    type: SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateLineaFinancieraPending: true,
        updateLineaFinancieraError: null,
      };

    case SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_SUCCESS:
      // The request is success
      return {
        ...state,
        updateLineaFinancieraPending: false,
        updateLineaFinancieraError: null,
      };

    case SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_FAILURE:
      // The request is failed
      return {
        ...state,
        updateLineaFinancieraPending: false,
        updateLineaFinancieraError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_UPDATE_LINEA_FINANCIERA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateLineaFinancieraError: null,
      };

    default:
      return state;
  }
}
